export default class SoundController {
  static sounds = {
    flap: "/assets/audio/flap.mp3",
    die: "/assets/audio/die.mp3",
    hit: "/assets/audio/hit.mp3",
    score: "/assets/audio/score.mp3"
  };
  static isLoaded = false;

  static loadSound(key, src) {
    return new Promise((resolve) => {
      const audio = new Audio();
      audio.addEventListener("canplaythrough", () => {
        this.sounds[key] = audio;
        resolve();
      });
      audio.src = src;
      audio.load();
    });
  }

  static preloadSounds(callback) {
    
    if(this.isLoaded) {
      callback();
      return;
    }
    const promises = Object.entries(this.sounds).map(([key, src]) =>
      this.loadSound(key, src)
    );
    Promise.all(promises).then(()=> {
      this.isLoaded = true;
      callback();
    });
  }

  static playSound(key) {
    const sound = this.sounds[key];
    if (sound) {
      sound.currentTime = 0;
      sound.play();
    }
  }

  static dispose() {
    // Detener y liberar recursos de los objetos de sonido
    if(this.isLoaded) {
      Object.values(this.sounds).forEach((sound) => {
        sound.pause();
        sound.src = "";
      });
    }
  
    // Restablecer propiedades estáticas a sus valores iniciales
    this.sounds = {
      flap: "/assets/audio/flap.mp3",
      die: "/assets/audio/die.mp3",
      hit: "/assets/audio/hit.mp3",
      score: "/assets/audio/score.mp3"
    };

    this.isLoaded = false;
  }
}
